<template>
  <div class="add-item-view">
    <!-- Toast powodzenia -->
    <div v-if="showToast" class="success-toast">
      ✓ Spotkanie zostało dodane!
    </div>

    <!-- Nagłówek -->
    <div class="page-header">
      <div class="header-content">
        <h3 class="page-title">Dodaj nowe spotkanie</h3>
        <p class="page-subtitle">Wypełnij formularz aby dodać nowe spotkanie do kalendarza</p>
      </div>
      <router-link to="/meetings-archive">
        <button class="btn-back">
          ← Powrót do listy
        </button>
      </router-link>
    </div>

    <!-- Formularz -->
    <div class="form-container">
      <form @submit.prevent="addNewMeeting">
        
        <!-- Sekcja danych kontaktowych -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">👤</span>
            Dane kontaktowe
          </h5>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Imię i nazwisko *</label>
              <input
                v-model="clientName"
                type="text"
                class="form-input"
                placeholder="np. Jan Kowalski"
              />
              <div v-if="!clientName && formTouched" class="error-message">
                Imię i nazwisko jest wymagane
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Numer telefonu</label>
              <input
                v-model="clientPhone"
                type="tel"
                class="form-input"
                placeholder="np. 123 456 789"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">E-mail</label>
            <input
              v-model="clientEmail"
              type="email"
              class="form-input"
              placeholder="np. email@example.com"
            />
          </div>
        </div>

        <!-- Sekcja szczegółów spotkania -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">📍</span>
            Szczegóły spotkania
          </h5>

          <div class="form-group">
            <label class="form-label">Adres spotkania *</label>
            <input
              v-model="clientAdres"
              type="text"
              class="form-input"
              placeholder="np. ul. Przykładowa 123, Warszawa"
            />
            <div v-if="!clientAdres && formTouched" class="error-message">
              Adres spotkania jest wymagany
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data spotkania *</label>
              <input
                v-model="meetingDate"
                type="date"
                class="form-input"
              />
              <div v-if="!meetingDate && formTouched" class="error-message">
                Data spotkania jest wymagana
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Godzina spotkania *</label>
              <input
                v-model="meetingTime"
                type="time"
                class="form-input"
              />
              <div v-if="!meetingTime && formTouched" class="error-message">
                Godzina spotkania jest wymagana
              </div>
            </div>
          </div>
        </div>

        <!-- Sticky footer z przyciskiem -->
        <div class="form-footer">
          <button
            type="submit"
            class="btn-submit"
            :disabled="!clientName || !clientAdres || !meetingDate || !meetingTime"
          >
            <span class="submit-icon">✓</span>
            Dodaj spotkanie
          </button>
          <router-link to="/meetings-archive" class="btn-cancel">
            Anuluj
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import router from "../router/index";

export default {
  data() {
    return {
      clientName: "",
      clientAdres: "",
      clientPhone: "",
      clientEmail: "",
      meetingDate: "",
      meetingTime: "",
      formTouched: false,
      showToast: false,
    };
  },
  methods: {
    addNewMeeting() {
      this.formTouched = true;
      
      if (!this.clientName || !this.clientAdres || !this.meetingDate || !this.meetingTime) {
        return;
      }

      this.$store
        .dispatch("createNewMeeting", {
          client: this.clientName,
          adres: this.clientAdres,
          phoneNr: this.clientPhone,
          email: this.clientEmail,
          date: this.meetingDate,
          time: this.meetingTime
        })
        .then(() => {
          this.showSuccessToast();
          setTimeout(() => {
            router.push("/meetings-archive");
          }, 1500);
        })
        .catch((err) => {
          alert("Błąd podczas dodawania spotkania: " + err);
        });
    },
    showSuccessToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
/* --- Layout główny --- */
.add-item-view {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* --- Nagłówek strony --- */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 35px 40px;
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  flex: 1;
}

.page-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: white;
  letter-spacing: -0.5px;
}

.page-subtitle {
  margin: 8px 0 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.btn-back {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateX(-4px);
}

/* --- Kontener formularza --- */
.form-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 100px;
}

/* --- Sekcje formularza --- */
.form-section {
  margin-bottom: 35px;
  padding-bottom: 35px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 20px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  font-size: 24px;
}

/* --- Pola formularza --- */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
}

.form-input,
.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #2d3748;
  transition: all 0.2s ease;
  background: white;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #a0aec0;
}

/* --- Komunikaty błędów --- */
.error-message {
  color: #e53e3e;
  font-size: 13px;
  margin-top: 6px;
  font-weight: 500;
}

/* --- Sticky footer --- */
.form-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  z-index: 100;
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-icon {
  font-size: 18px;
  font-weight: bold;
}

.btn-cancel {
  color: #718096;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  padding: 14px 24px;
  transition: all 0.2s ease;
  background: transparent;
  border: none;
  cursor: pointer;
}

.btn-cancel:hover {
  color: #2d3748;
}

/* --- Toast powodzenia --- */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(72, 187, 120, 0.4);
  font-size: 15px;
  font-weight: 600;
  z-index: 1000;
  animation: slideIn 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 25px 20px;
  }

  .page-title {
    font-size: 24px;
  }

  .form-container {
    padding: 25px 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-footer {
    flex-direction: column;
    padding: 15px 20px;
  }
}
</style>

